import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import SwitchControl from 'components/SwitchControl';
import CheckboxControl from 'components/CheckboxControl';
import SelectControl from 'components/SelectControl';
import TimeConstant from 'constants/Time';

import './TimePane.scss';

const STATUS = ['nothing', 'exact', 'interval'];
const DEFAULT_FROM = TimeConstant.Hours[16].value;
const DEFAULT_TO = TimeConstant.Hours[36].value;

class TimePane extends Component {

    static propTypes = {
        className: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
        valueFrom: PropTypes.number,
        valueTo: PropTypes.number,
        status: PropTypes.oneOf(STATUS),
        onTimeOnOff: PropTypes.func,
        onIntervalOnOff: PropTypes.func,
        onTimeFromChange: PropTypes.func,
        onTimeToChange: PropTypes.func,
    };

    static defaultProps = {
        disabled: false,
        status: 'nothing',
    };

    state = {
        valueFrom: this.props.valueFrom,
        valueTo: this.props.valueTo,
        status: this.props.status,
        timeFrom: '',
        timeTo: '',
        interval: '',
        label: '',
        switchChecked: false,
    }

    componentWillMount() {
        var status = this.props.status;
        if (this.props.valueFrom) {
            status = 'exact'
        };
        if (this.props.valueTo) {
            status = 'interval'
        };

        this._renderDependingStatus({
            status: status,
            valueFrom: this.props.valueFrom,
            valueTo: this.props.valueTo,
        });
    }

    _renderDependingStatus = (object) => {
        var timeFrom = '';
        var timeTo = '';
        var interval = '';
        var label = '';
        var status = this.state.status;
        var valueFrom = this.state.valueFrom;
        var valueTo = this.state.valueTo;

        if (object) {
            if (object.status) {
                status = object.status;
            }
            if (object.valueFrom || object.valueFrom === null) {
                valueFrom = object.valueFrom;
            }
            if (object.valueTo || object.valueTo === null) {
                valueTo = object.valueTo;
            }
        }

        switch (status) {
            case 'exact':
                timeFrom = (
                    <SelectControl className="TimePane-select"
                        selectType="time"
                        attribute="timeFrom"
                        value={valueFrom}
                        onChange={this._onTimeFromChange}/>
                );
                interval = (
                    <CheckboxControl
                        className="TimePane-checkbox"
                        label="Интервал"
                        value={false}
                        onChange={this._onIntervalCheckboxChange} />
                );
                break
            case 'interval':
                timeFrom = (
                    <SelectControl className="TimePane-select TimePane-select--from"
                        selectType="time"
                        attribute="timeFrom"
                        value={valueFrom}
                        onChange={this._onTimeFromChange}/>
                );
                interval = (
                    <CheckboxControl
                        className="TimePane-checkbox"
                        label="Интервал"
                        value={true}
                        onChange={this._onIntervalCheckboxChange} />
                );
                timeTo = (
                    <SelectControl className="TimePane-select TimePane-select--to"
                        selectType="time"
                        value={valueTo}
                        onChange={this._onTimeToChange}/>
                );
                break
            default:
                label = (
                    <span className="TimePane-label"
                        onClick={this._onLabelClick}>
                        Указать точное время
                    </span>
                );
        };

        this.setState({
            timeFrom: timeFrom,
            timeTo: timeTo,
            interval: interval,
            label: label,
            status: status,
            valueFrom: valueFrom,
            valueTo: valueTo,
        });

        this._emitChange({
            from: valueFrom,
            to: valueTo,
        });
    }

    _onChange = (newValue) => {
        if (this.props.onChange) this.props.onChange(null, [newValue]);
    }

    _onTimeFromChange = (e, value) => {
        this.setState({
            valueFrom: value,
        });

        this._emitChange({
            from: value,
            to: this.state.valueTo,
        });

        if (this.props.onTimeFromChange) {
            this.props.onTimeFromChange(value[0])
        }
    }

    _onTimeToChange = (e, value) => {
        this.setState({
            valueTo: value,
        });

        this._emitChange({
            from: this.state.valueFrom,
            to: value,
        });

        if (this.props.onTimeToChange) {
            this.props.onTimeToChange(value[0])
        }
    }

    _onSwitchChange = (e, value) => {
        if (value) {
            this._renderDependingStatus({
                status: 'exact',
                valueFrom: this.props.valueFrom || DEFAULT_FROM,
                valueTo: null,
            });

            if (this.props.onTimeOnOff) {
                this.props.onTimeOnOff();
            }
        } else {
            this._renderDependingStatus({
                status: 'nothing',
                valueTo: null,
                valueFrom: null,
            });
        }
    }

    _onLabelClick = (e) => {
        this._renderDependingStatus({
            status: 'exact',
            valueFrom: this.props.valueFrom || DEFAULT_FROM,
            valueTo: null,
        });

        if (this.props.onTimeOnOff) {
            this.props.onTimeOnOff();
        }
    }

    _onIntervalCheckboxChange = (e, value) => {
        if (value) {
            this._renderDependingStatus({
                status: 'interval',
                valueTo: this.props.valueTo || DEFAULT_TO,
            });

            if (this.props.onIntervalOnOff) {
                this.props.onIntervalOnOff();
            }
        } else {
            this._renderDependingStatus({
                status: 'exact',
                valueTo: null,
            });
        }
    }

    _emitChange = (time) => {
        var from = parseInt(time.from);
        var to = parseInt(time.to);

        if (from === to) {
            to = null;
        }

        if (this.props.onChange) {
            this.props.onChange({
                from: isNaN(from) ? null : from,
                to: isNaN(to) ? null : to,
            })
        }
    }

    render() {
        var {className, onChange, ...props} = this.props;
        var timeClass = classNames('TimePane', className);

        return (
            <div className={ timeClass }>
                <SwitchControl className="TimePane-switch"
                    onChange={this._onSwitchChange}
                    label="Время"
                    labelPos="top"
                    size="m"
                    checked={this.state.status === 'exact' || this.state.status === 'interval'}/>
                { this.state.label }
                { this.state.timeFrom }
                { this.state.timeTo }
                { this.state.interval }
            </div>
        );
    }
}

export default TimePane;



// WEBPACK FOOTER //
// ./client/components/TimePane/TimePane.js